import React from 'react';
import { Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import Table from '../ui/Table';

const DetallesProfesorCell = ({ original, onVerDetalle }) => (
  <Button color="success" onClick={() => onVerDetalle(original.Centro, original.Codigo)}>
    Detalles
  </Button>
);
DetallesProfesorCell.propTypes = {
  original: PropTypes.shape({
    Centro: PropTypes.string.isRequired,
    Codigo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  onVerDetalle: PropTypes.func.isRequired,
};

const TablaProfesores = ({ data }) => {
  const navigate = useNavigate();

  const columns = [
    {
      Header: 'Código',
      accessor: 'Codigo',
    },
    {
      Header: 'Nombre',
      accessor: 'Nombre',
    },
    {
      Header: 'Apellidos',
      accessor: 'Apellidos',
    },
    {
      Header: 'Móvil',
      accessor: 'Movil',
    },
    {
      Header: 'Email',
      accessor: 'Email personal',
    },
    {
      Header: 'Centro',
      accessor: 'Centro',
    },
    {
      Header: 'Acciones',
      CellComponent: DetallesProfesorCell,
      cellProps: {
        onVerDetalle: (centro, codigo) => navigate(`/profesores/${centro}/${codigo}/detalles`),
      },
      sortable: false,
      filterable: false,
      width: 120,
    },
  ];

  return (
    <Table
      data={data}
      columns={columns}
      defaultPageSize={10}
      className="-striped -highlight mt-5 text-center"
    />
  );
};

TablaProfesores.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default TablaProfesores;
